import type { SignalDetailResponse, SignalView } from "../../lib/queries.js";
import { useSignal } from "../../lib/signals-queries.js";

/**
 * One query, not eight.
 *
 * The reference composes eight requests here because its API has no detail
 * endpoint. `GET /api/signals/:id` returns the signal and the context its
 * focus chart needs together, so the round trip is already paid and this hook
 * is only unpacking.
 */
export interface SignalDetailData {
  signal: SignalView | undefined;
  context: SignalDetailResponse["context"] | undefined;
  isPending: boolean;
  isError: boolean;
  error: Error | null;
}

export function useSignalDetailData(signalId: string): SignalDetailData {
  const query = useSignal(signalId);
  return {
    signal: query.data?.signal,
    context: query.data?.context,
    isPending: query.isPending,
    isError: query.isError,
    error: (query.error as Error | null) ?? null,
  };
}
